// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 9268) return "static/chunks/aaea2bcf-fa3a5822370d1890.js";
	if (chunkId === 4134) return "static/chunks/4134-32f3034fdf34bdb8.js";
	if (chunkId === 5221) return "static/chunks/5221-8aeea0fa79ada941.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"398":"3784446431331c19","526":"d575fd232588dcd1","1361":"e3aa723e065c5fb2","1822":"88062529780b9e3f","2049":"24e233dd8cded06a","3165":"be2f972c1898bbe3","6083":"e90b2f80d263fca5","6164":"43f6f2b148f3ac7d","8221":"23324f05af03ba91","8342":"795e46b7f880c5f0","9455":"fd0ea695acf5ce5f"}[chunkId] + ".js";
};